import { estadoDeUnidad, ETIQUETAS_ESTADO } from "../../services/cols/estado";

// Cinco estados, no dos.
//
// El valor que llega puede ser el `estadoReal` ya resuelto por el service
// —que para tractores incluye "Vendido" y "Sin actividad", que salen de
// `estado_calculado`— o el crudo de la base ("1", "0", "false", null...),
// según de qué colección venga la columna. Los dos casos se aceptan.
//
// Antes esto pintaba de rojo todo lo que no fuera exactamente "Activo", así
// que "Sin dato" se leía como una baja. No es lo mismo: una baja es una
// decisión tomada, un dato faltante es una tarea pendiente. Van en gris.
//
// Los nombres de tono son los COMPARTIDOS con FlotaBot (`estilo_comun.py`):
// mal / ojo / ok / gris. Antes eran `status-pill--danger` y compañía, que era
// la misma pastilla con otro vocabulario — y con dos vocabularios para una
// sola cosa, la tercera pantalla inventa un tercero. Ya había pasado: el
// panel del taller la llamaba `.est`.
const CLASES = {
  activo: "ok",
  baja: "mal",
  vendido: "mal",
  // Chocado e irreparable NO son lo mismo, aunque los dos frenen el camión:
  // del chocado se vuelve y del irreparable no. Por eso uno avisa y el otro
  // es una baja — fundidos, «chocado» se leería como el final de la unidad.
  chocado: "ojo",
  irreparable: "mal",
  "sin-actividad": "ojo",
  "sin-dato": "gris",
};

// Vuelta del texto ya resuelto a su clave, para los estados que
// `estadoDeUnidad` no puede deducir del campo crudo.
const DESDE_TEXTO = Object.fromEntries(
  Object.entries(ETIQUETAS_ESTADO).map(([clave, texto]) => [
    texto.toLowerCase(),
    clave,
  ]),
);

/* `declarado` marca los que cargó una persona, y no es cosmético: «Activo»
 * porque el camión reportó kilómetros es un hecho de la telemetría, y «Chocado»
 * porque alguien lo cargó es alguien que fue a mirar — si está mal, hay a quién
 * preguntarle. Sin la distinción, un estado declarado hace un año se lee igual
 * que uno recalculado anoche. */
const EstadoPill = ({ valor, declarado = false, enTaller = false, tallerMotivo = null }) => {
  const texto = String(valor ?? "")
    .trim()
    .toLowerCase();
  const estado = DESDE_TEXTO[texto] ?? estadoDeUnidad(valor);

  /* EN EL TALLER = CONDICIONAL (#114, pedido de Aldo). Calculado al mirar
   * desde las estadías abiertas, nunca escrito en el padrón. Sólo tapa a
   * «Activo» y «Sin dato»: una baja, un vendido o un chocado son decisiones
   * más fuertes que una estadía — un camión vendido que quedó en el taller
   * sigue siendo un camión vendido. */
  if (enTaller && (estado === "activo" || estado === "sin-dato")) {
    return (
      <span
        className="pill ojo"
        title={
          "En el taller" +
          (tallerMotivo ? ` — ${tallerMotivo}` : "") +
          ". Vuelve a Activo solo, cuando el taller lo libere."
        }
      >
        Condicional
      </span>
    );
  }

  return (
    <span
      className={`pill ${CLASES[estado]}`}
      title={declarado
        ? "Lo cargó una persona; el sistema no lo va a pisar."
        : undefined}
    >
      {ETIQUETAS_ESTADO[estado]}
      {declarado && <i className="pill-marca" aria-label="cargado a mano"> ·✎</i>}
    </span>
  );
};

export default EstadoPill;
